import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22aa712f")

_pushScopeId("data-v-22aa712f")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex-center margin-top-10" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_demo_list = _resolveComponent("demo-list")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.playListSegments,
      class: "playlist-table",
      "row-key": "rowKey",
      border: "",
      "default-expand-all": "",
      "tree-props": {children: 'playlist'}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "时段",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "startTime",
          label: "开始时间",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "endTime",
          label: "结束时间",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          label: "标题",
          width: "180"
        }, {
          default: _withId(({row}) => [
            (row.parent)
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  (!_ctx.isEditing)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(row.title), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode(_component_el_input, {
                          size: "mini",
                          modelValue: row.title,
                          "onUpdate:modelValue": ($event: any) => (row.title = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (row.title.trim() === '')
                          ? (_openBlock(), _createBlock(_component_el_alert, {
                              key: 0,
                              title: "标题必填",
                              type: "error",
                              closable: false,
                              "show-icon": ""
                            }))
                          : _createCommentVNode("", true)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "音频" }, {
          default: _withId(({row}) => [
            (row.parent)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("audio", {
                    controls: "",
                    src: row.audioUrl
                  }, null, 8, ["src"]),
                  (!row.audioUrl)
                    ? (_openBlock(), _createBlock(_component_el_alert, {
                        key: 0,
                        title: "未选择音频",
                        type: "error",
                        closable: false,
                        "show-icon": ""
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              fixed: "right",
              label: "操作"
            }, {
              default: _withId(({row}) => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    circle: "",
                    type: "success",
                    icon: "el-icon-plus",
                    onClick: ($event: any) => (_ctx.addAudio(row))
                  }, null, 8, ["onClick"]),
                  (row.parent)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "mini",
                        circle: "",
                        type: "danger",
                        icon: "el-icon-minus",
                        onClick: ($event: any) => (_ctx.removeAudio(row))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.parent)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "mini",
                        type: "primary",
                        class: "margin-left-10",
                        onClick: ($event: any) => (_ctx.selectDemoFor(row))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(!!row.audioUrl ? '更换' : '选择') + "音乐 ", 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode("div", _hoisted_6, [
      (!_ctx.isEditing && !_ctx.isPastDay)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditing=true))
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: _ctx.cancel
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      title: "选择音频",
      top: "10px",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: "80%"
    }, {
      default: _withId(() => [
        _createVNode(_component_demo_list, {
          onDemoSelected: _ctx.demoSelected,
          isSelectorMode: true
        }, null, 8, ["onDemoSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})